import { render, staticRenderFns } from "./isDeleted.vue?vue&type=template&id=f0b47e00&scoped=true"
import script from "./isDeleted.vue?vue&type=script&lang=js"
export * from "./isDeleted.vue?vue&type=script&lang=js"
import style0 from "./isDeleted.vue?vue&type=style&index=0&id=f0b47e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b47e00",
  null
  
)

export default component.exports